import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { map } from 'lodash';
import { useSelector } from 'react-redux';
import SVG from 'react-inlinesvg';

import { formatDateToLocale } from 'app/utils/dates';
import { PACK_TYPE_NUMBER } from 'app/utils/constants';
import { toAbsoluteUrl } from 'app/utils/toAbsoluteUrl';
import ModalLanguages from 'app/modules/Downloads/components/ModalLanguages';
import ModalWrongPack from 'app/components/ModalWrongPack';
import ModalCountries from 'app/modules/Downloads/components/ModalCountries';

import 'app/modules/Downloads/components/CategoryList/CategoryList.scss';
import { getMediaZipFiles } from 'app/api/downloads/getMediaZipFiles';
import Spinner from 'app/components/Spinner';

export default function CategoryList({ list }) {
  const [idsLang, setIdsLang] = useState([]);
  const [idsCountry, setIdsCountry] = useState([]);
  const [idCategory, setIdCategory] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [title, setTitle] = useState('');
  const [showModalWrongPack, setModalWrongPack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadType, setDownloadType] = useState('');

  if (loading) return <Spinner />;

  return (
    <>
      <ModalWrongPack show={showModalWrongPack} setShow={setModalWrongPack} />
      {downloadType === 'countries' ? (
        <ModalCountries
          title={title}
          idCategory={idCategory}
          setIdCategory={setIdCategory}
          viewModal={viewModal}
          setViewModal={setViewModal}
          idsCountry={idsCountry}
          setIdsCountry={setIdsCountry}
          countries={list.meta.availableReferenceShippingCostCountryIsoCodes}
        />
      ) : (
        <ModalLanguages
          title={title}
          idCategory={idCategory}
          setIdCategory={setIdCategory}
          viewModal={viewModal}
          setViewModal={setViewModal}
          idsLang={idsLang}
          setIdsLang={setIdsLang}
        />
      )}
      <div className="category-list">
        {map(list?.data, (section, key) => (
          <div className="category-list__section" key={key}>
            <p className="category-list__section-title">
              {section?.attributes?.title}
            </p>
            <div>
              {map(section?.attributes?.elements, (category, index) => (
                <Children
                  idSection={section?.id}
                  downloadable={section?.attributes?.downloadable}
                  key={index}
                  data={category}
                  setIdCategory={setIdCategory}
                  setViewModal={setViewModal}
                  setTitle={setTitle}
                  setModalWrongPack={setModalWrongPack}
                  setLoading={setLoading}
                  setDownloadType={setDownloadType}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

CategoryList.propTypes = {
  list: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    meta: PropTypes.shape({
      availableReferenceShippingCostCountryIsoCodes: PropTypes.arrayOf(
        PropTypes.shape({})
      )
    })
  }).isRequired
};

const Children = ({
  data,
  setViewModal,
  setIdCategory,
  setTitle,
  setModalWrongPack,
  idSection,
  downloadable,
  setLoading,
  setDownloadType
}) => {
  const { type, name, date, directDownload, downloadType } = data;

  const {
    user: {
      attributes: { packId }
    }
  } = useSelector((state) => state.auth);

  const clickFnc = () => {
    if (directDownload || packId === PACK_TYPE_NUMBER?.PRO) {
      setLoading(true);
      (async () => {
        const request = await getMediaZipFiles([idSection], 'csv-section', []);
        if (request?.links?.download_url) {
          window.open(request?.links?.download_url);
        }
        setLoading(false);
      })();

      return true;
    }

    if (downloadable && packId !== PACK_TYPE_NUMBER?.PRO) {
      setViewModal(true);
      setIdCategory(idSection);
      setTitle(name);
      setDownloadType(downloadType || '');
      return true;
    }

    setModalWrongPack(true);
    return true;
  };

  return (
    <div
      className="category-list__section-children"
      onClick={clickFnc}
      role="button"
      onKeyDown={clickFnc}
      tabIndex={0}
    >
      <div className="icon">
        <SVG
          src={toAbsoluteUrl(`/media/svg/bbfiles/${type.toLowerCase()}.svg`)}
        />
      </div>
      <div className="description">
        <p className="small bold">{name}</p>
        {date && (
          <p className="date small">{formatDateToLocale(date * 1000)}</p>
        )}
      </div>
    </div>
  );
};

Children.propTypes = {
  idSection: PropTypes.string.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    date: PropTypes.number,
    directDownload: PropTypes.bool,
    downloadType: PropTypes.string
  }).isRequired,
  setViewModal: PropTypes.func.isRequired,
  setIdCategory: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired,
  setModalWrongPack: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  downloadable: PropTypes.bool.isRequired,
  setDownloadType: PropTypes.func.isRequired
};
